export interface Decoration {
  id: string
  name: string
  category: 'plant' | 'rock' | 'background' | 'prop'
  price: number
  emoji: string
  description: string
  effect: { moodBonus?: number; energyBonus?: number }
  width: number
  height: number
  zIndex: number
}

export const DECORATIONS: Decoration[] = [
  {
    id: 'plant1',
    name: '金鱼草',
    category: 'plant',
    price: 20,
    emoji: '🌿',
    description: '翠绿的水草，为鱼缸增添生机',
    effect: { moodBonus: 5 },
    width: 40,
    height: 80,
    zIndex: 1,
  },
  {
    id: 'plant2',
    name: '水榕',
    category: 'plant',
    price: 30,
    emoji: '🌱',
    description: '叶片宽大，适合鱼群躲藏',
    effect: { moodBonus: 8 },
    width: 50,
    height: 60,
    zIndex: 1,
  },
  {
    id: 'plant3',
    name: '蜈蚣草',
    category: 'plant',
    price: 15,
    emoji: '🌾',
    description: '细长飘逸，随水流摆动',
    effect: { moodBonus: 3 },
    width: 20,
    height: 90,
    zIndex: 1,
  },
  {
    id: 'rock1',
    name: '火山岩',
    category: 'rock',
    price: 25,
    emoji: '🪨',
    description: '多孔结构，有益硝化细菌生长',
    effect: { energyBonus: 5 },
    width: 60,
    height: 40,
    zIndex: 2,
  },
  {
    id: 'rock2',
    name: '珊瑚礁',
    category: 'rock',
    price: 45,
    emoji: '🪸',
    description: '色彩斑斓，增添热带风情',
    effect: { moodBonus: 10 },
    width: 70,
    height: 50,
    zIndex: 2,
  },
  {
    id: 'rock3',
    name: '沉木',
    category: 'rock',
    price: 35,
    emoji: '🪵',
    description: '天然木材，营造自然氛围',
    effect: { energyBonus: 8 },
    width: 80,
    height: 30,
    zIndex: 2,
  },
  {
    id: 'bg1',
    name: '海底城堡',
    category: 'background',
    price: 100,
    emoji: '🏰',
    description: '梦幻的水下城堡背景',
    effect: { moodBonus: 15 },
    width: 100,
    height: 100,
    zIndex: 0,
  },
  {
    id: 'bg2',
    name: '深海',
    category: 'background',
    price: 80,
    emoji: '🌊',
    description: '神秘的深海渐变背景',
    effect: { energyBonus: 12 },
    width: 100,
    height: 100,
    zIndex: 0,
  },
  {
    id: 'bg3',
    name: '热带海滩',
    category: 'background',
    price: 90,
    emoji: '🏖️',
    description: '阳光沙滩的热带风情',
    effect: { moodBonus: 12, energyBonus: 5 },
    width: 100,
    height: 100,
    zIndex: 0,
  },
  {
    id: 'prop1',
    name: '宝箱',
    category: 'prop',
    price: 50,
    emoji: '📦',
    description: '古老的海盗宝箱',
    effect: { moodBonus: 5 },
    width: 45,
    height: 35,
    zIndex: 3,
  },
  {
    id: 'prop2',
    name: '沉船',
    category: 'prop',
    price: 70,
    emoji: '🚢',
    description: '迷你沉船模型',
    effect: { energyBonus: 10 },
    width: 60,
    height: 45,
    zIndex: 3,
  },
  {
    id: 'prop3',
    name: '潜水员',
    category: 'prop',
    price: 60,
    emoji: '🤿',
    description: '可爱的迷你潜水员',
    effect: { moodBonus: 8 },
    width: 35,
    height: 50,
    zIndex: 3,
  },
]

export interface PlacedDecoration {
  decorationId: string
  x: number
  y: number
  rotation: number
}

export const CATEGORY_LABELS: Record<string, string> = {
  plant: '水草',
  rock: '岩石',
  background: '背景',
  prop: '摆件',
}
